import { lazy } from 'react';
export var CalendarPageAsync = lazy(function () { return import('./CalendarPage'); });
